import React,{useState} from 'react'

export default function GlobalFilter({preGlobalFilteredRows, globalFilter, setGlobalFilter, useAsyncDebounce}) {

    const count = preGlobalFilteredRows.length
    const [value, setValue] = useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
      setGlobalFilter(value || undefined)
    }, 200)
  
    return (
      <div
        className="col-lg-2 mb-5"
      >
        <input
          value={value || ""}
          onChange={e => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          placeholder={`${count} records...`}
          className="form-control"
          
        />
        <span className="form-text text-muted"><b>Search</b> in all fields</span>
      </div>
    )
}
